import axios from './axios'

function service(endpoint) {

    function fetchComponents() {
        return axios.get(`${endpoint}/components`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchMedicines() {
        return axios.get(`${endpoint}/medicines`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchComponents,
        fetchMedicines
    }
}

export default service
